import { NameInputs, PasswordInputs } from 'components/SignUp';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/AccountSettings/PageProvider';
import { useContext } from 'react';
import { Box, Container, Copyright, Logo, Stack, styled } from 'shell/components';

const Tablet = () => {
    const { device } = useViewport();
    const {
        currentStep,
        errors,
        form,
        satisfyRequirement,
        handleChange,
        handlePrev,
        handleNext,
        handleComplete,
        PAGES,
    } = useContext(PageContext);

    return (
        <Container device={device} sx={{ height: '100%' }}>
            <CenterBox>
                <Stack alignItems={'center'}>
                    <Logo device={'desktop'} />
                </Stack>
                {currentStep === PAGES.NAME && (
                    <NameInputs
                        form={form}
                        errors={errors}
                        handleChange={handleChange}
                        handleNext={() => handleNext(PAGES.NEW_PASSWORD)}
                    />
                )}
                {currentStep === PAGES.NEW_PASSWORD && (
                    <PasswordInputs
                        form={form}
                        errors={errors}
                        satisfyRequirement={satisfyRequirement}
                        handleChange={handleChange}
                        handlePrev={() => handlePrev(PAGES.NAME)}
                        handleNext={handleComplete}
                    />
                )}
            </CenterBox>
            <Copyright />
        </Container>
    );
};

const CenterBox = styled(Box)(({ theme }) => {
    return {
        paddingTop: theme.spacing(18),
        width: 'fit-content',
        height: '100%',
    };
});

export default Tablet;
